
import {AnimationAction, PlayerAnimations} from "./animation";
import {ActionType, TwinType} from "../enums";
import ServerMQTT from "../utils/mqtt";
import ServerSocket from "../utils/socket";
import {TwinConfig} from "../panda";
import {Object3D, Scene,Material} from "three";
import {MyPlayer} from "../player";
import * as THREE from "three";
import * as TWEEN from "@tweenjs/tween.js";

class PlayerTwin {
    animations: PlayerAnimations;
    type: string
    mqtt?: ServerMQTT
    websocket?: ServerSocket
    constructor( scene:Scene, twin:TwinConfig,animations:PlayerAnimations ) {
        this.animations = animations
        this.type = twin.twinType
        if (twin.twinType === TwinType.MQTT){
            this.mqtt = new ServerMQTT(twin.url,twin.username,twin.password,twin.topic,twin.pubTopic)
            this.mqtt?.init(this.onMqttTwinOperation)
            console.info("MQTT连接成功")
        }
        if (twin.twinType === TwinType.WebSocket){
            if (!('WebSocket' in window)) {
                console.warn('浏览器不支持WebSocket')
                return null
            }
            this.websocket = new ServerSocket(twin.url)
            this.websocket?.init(twin.screenId, this.onSocketTwinOperation)
            console.info("Websocket连接成功")
        }
    }
    sendMsg(msg:any){
        if (this.type === TwinType.MQTT){
            this.mqtt?.send(msg)
        }
        if (this.type === TwinType.WebSocket){
            this.websocket?.send("CONTROLCMD"+msg,this.sendSucCallBack)
        }
    }
    close(){
        if (this.type === TwinType.MQTT){
            this.mqtt?.close()
        }
        if (this.type === TwinType.WebSocket){
            this.websocket?.send("LEAVE")
            //this.websocket?.close()
        }
    }
    sendSucCallBack(){
        console.log("发送消息成功")
    }
    onMqttTwinOperation (topic:string,message:any){
        //解析topic 获取分类Id和孪生体Id
        const tps = topic.split("/")
        if (tps.length < 2) {
            return
        }
        const data = JSON.parse(message.toString())
        data.twinId = tps[tps.length-1]
        MyPlayer.globalPlayer?.scene.traverse(object => {
            if (object.userData.twinDatas && object.userData.twinDatas.length>0) {
                const twinDatas = object.userData.twinDatas
                runTwin(object,data,twinDatas)
            }
        });

    }
    onSocketTwinOperation (message:any){
        const msgData = JSON.parse(message.data)
        if (msgData["MESSAGETYPE"] === "01"){
            const data = msgData["MESSAGECONTENT"]
            MyPlayer.globalPlayer?.scene.traverse(object => {
                if (object.userData.twinDatas && object.userData.twinDatas.length>0) {
                    const twinDatas = object.userData.twinDatas
                    runTwin(object,data,twinDatas)
                }
            });
        }
        if (msgData["MESSAGETYPE"] === "02") {
            console.info("指令发送成功")
        }
        if (msgData["MESSAGETYPE"] === "03") {
            console.info("收到心跳包")
        }
    }
}

function isFilterTrue(value: any, data: any) {
    let isTrue = false
    switch (data.filter) {
        case '=':
            if (value == data.dataValue){
                isTrue = true
            }
            break;
        case '!=':
            if (value != data.dataValue){
                isTrue = true
            }
            break;
        case '>':
            if (value > data.dataValue){
                isTrue = true
            }
            break;
        case '<':
            if (value < data.dataValue){
                isTrue = true
            }
            break;
        case '>=':
            if (value >= data.dataValue){
                isTrue = true
            }
            break;
        case '<=':
            if (value <= data.dataValue){
                isTrue = true
            }
            break;
    }
    return isTrue
}

const conditions = (condition:any,twinData:any,data:any ) => {
    let bool = false
    if (data.twinId === twinData.twinId){
        bool = isFilterTrue(data[twinData.attrKey], condition)
    }
    return bool
}

const setMaterialValue = (object, key, value)=>{
    if (object instanceof THREE.Group){
        object.traverse(function(child) {
          if (child instanceof THREE.Mesh) {
            if (key as String === 'opacity' ){
              // 判断是否开启transparent
              if ((child.material instanceof Material) && !child.material.transparent){
                child.material['transparent'] = true;
              }
            }
            child.material[ key ] = value;
          }
        });
      }
      if (object instanceof THREE.Mesh) {
        if (key as String === 'opacity' ){
          // 判断是否开启transparent
          if ((object.material instanceof Material) && !object.material.transparent){
            object.material['transparent'] = true;
          }
        }
        object.material[ key ] = value;
      }
}

function runTwin(object:Object3D,data:any,twinDatas:any) {
    twinDatas.forEach((twinData:any)=>{
        if (twinData.conditions && (twinData.conditions.length > 0)){
            for (let i = 0; i < twinData.conditions.length; i++) {
                const condition = twinData.conditions[i]
                switch (condition.action.action) {
                    case ActionType.OpenUrl:
                        // 根据设置的条件判断结果
                        if (conditions(condition,twinData, data)) {
                            window.open(condition.action.url, "blank");
                        }
                        return
                    case ActionType.OpenAction:
                        if (conditions(condition,twinData, data)) {
                            let target1=MyPlayer.globalPlayer?.scene.getObjectByProperty('uuid', condition.action.node);
                            this.animations.runObjectAnimation(target1)
                        }
                        return;
                    case ActionType.StopAction:
                        if (conditions(condition, twinData,data)) {
                            let target2=MyPlayer.globalPlayer?.scene.getObjectByProperty('uuid', condition.action.node);
                            this.animations.stopObjectAnimation(target2)
                        }
                        return;
                    case ActionType.ChangeProperty:
                        if (conditions(condition, twinData,data) && condition.action.properties && condition.action.properties.length>0) {
                            condition.action.properties.forEach((item:any)=>{
                                // 设置模型属性
                                let target:any=MyPlayer.globalPlayer?.scene.getObjectByProperty('uuid', item.node);
                                if(target!==null && item.value){
                                    if(item.key === "visible"){
                                        target[ item.key ] = item.value;
                                    }
                                    if(item.key === "position"){
                                        const newPos = target.position.clone()
                                        if (item.value ){
                                            newPos.x = item.value.x;
                                            newPos.y = item.value.y;
                                            newPos.z = item.value.z;
                                        }
                                        target.position.copy( newPos );
                                        target.updateMatrixWorld( true );
                                    }
                                    if(item.key === "rotation"){
                                        const newPos = target.rotation.clone()
                                        if (item.value ){
                                            newPos.x = item.value.x;
                                            newPos.y = item.value.y;
                                            newPos.z = item.value.z;
                                        }
                                        target.rotation.copy( newPos );
                                        target.updateMatrixWorld( true );
                                    }
                                    if(item.key === "scale"){
                                        const newPos = target.scale.clone()
                                        if (item.value ){
                                            newPos.x = item.value.x;
                                            newPos.y = item.value.y;
                                            newPos.z = item.value.z;
                                        }
                                        target.scale.copy( newPos );
                                        target.updateMatrixWorld( true );
                                    }
                                    if(item.key === "color" || item.key ==="emissive"){
                                        let newColor = parseInt( item.value.substr( 1 ), 16 )
                                        let nc
                                        if (item.key === 'color'){
                                          nc = target.material.color.setHex(newColor)
                                        }
                                        if (item.key === 'emissive') {
                                          nc = target.material.emissive.setHex(newColor)
                                        }
                                        this.setMaterialValue(target,item.key,nc)
                                    }
                                    if(item.key === "opacity"){
                                        this.setMaterialValue(target,item.key,item.value)
                                    }
                                }
                            })
                        }
                        return;
                    case ActionType.HighlightObject:
                        if (conditions(condition, twinData,data)) {
                            let object1=MyPlayer.globalPlayer?.scene.getObjectByProperty('uuid', condition.action.node);
                            MyPlayer.globalPlayer?.effectComposer.addOutlinePass(object1)
                        }
                        return;
                    case ActionType.NoHighlightObject:
                        if (conditions(condition, twinData,data)) {
                            let object2=MyPlayer.globalPlayer?.scene.getObjectByProperty('uuid', condition.action.node);
                            MyPlayer.globalPlayer?.effectComposer.deleteOutlinePass(object2)
                        }
                        return;
                    case ActionType.TwinOper:
                        if (conditions(condition, twinData,data)) {
                            if (condition.action.twin) {
                                let value = condition.action.twinValue
                                if (condition.action.twin.attr.type === 'struct' || condition.action.twin.attr.type === 'array') {
                                    value = JSON.parse(condition.action.twinValue)
                                }
                                if (this.type === "MQTT") {
                                    MyPlayer.globalPlayer.twin.sendMsg(JSON.stringify({[ condition.action.twin.attrKey] : value}))
                                } else {
                                    MyPlayer.globalPlayer.twin.sendMsg(JSON.stringify({
                                        "twinId":  condition.action.twin.twinId,
                                        "attrs": {[ condition.action.twin.attrKey] : value}
                                    }))
                                }
                            }
                        }
                        return;
                    case ActionType.ChangeView:
                        if (conditions(condition, twinData,data)) {
                            const cameraPosition = MyPlayer.globalPlayer.camera.position.clone();
                            let worldDirection = new THREE.Vector3()
                            MyPlayer.globalPlayer.camera.getWorldDirection(worldDirection)
                            const cameraLookAt = new THREE.Vector3().addVectors(cameraPosition, worldDirection);
                            new TWEEN.Tween(cameraPosition)
                                .to(condition.action.view.position, condition.action.view.duration)
                                // tweenjs改变参数对象的过程中，.onUpdate方法会被重复调用执行
                                .onUpdate(function(){
                                    this.editor.camera.lookAt(cameraLookAt);
                                })
                                .start()
                        }
                        break;
                    case ActionType.FocusObject:
                        const tarObg= this.player.scene.getObjectByProperty('uuid',condition.action.node);
                        MyPlayer.globalPlayer.controls.createCameraTween(condition.action.time || 2000,tarObg)
                        break;
                }
            }
        }
    });
}

export { PlayerTwin };
